import React, { useState, useEffect, useRef } from 'react'
import styled from 'styled-components'
import useOnClickOutside from 'use-onclickoutside'

const Wrapper = styled.div`
  // position: relative;
`

const Selected = styled.div`
  position: relative;
  padding: 10px;
  width: 120px;
  border: 1px solid #eee;
  border-radius: 5px;
  cursor: pointer;

  &:after {
    content: '';
    display: block;
    position: absolute;
    top: 50%;
    right: 10px;
    border-top: 5px solid #444;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
  }
`

const Headings = styled.div`
  position: absolute;
  width: 120px;
  z-index:100;
  background-color: #fff;
  border: 1px solid #eee;
  box-shadow: 2px 2px 8px #ddd;
`

const Heading = styled.div`
  padding: 10px;
  cursor: pointer;

  &:hover {
    background-color: rgba(0, 102, 204, 0.1);
  }
`

const headings = [
  {
    format: 'heading-one',
    label: 'Rubrik 1'
  },
  {
    format: 'heading-two',
    label: 'Rubrik 2'
  },
  {
    format: 'heading-three',
    label: 'Rubrik 3'
  },
  {
    format: 'heading-four',
    label: 'Rubrik 4'
  },
  {
    format: 'heading-five',
    label: 'Rubrik 5'
  },
  {
    format: 'heading-six',
    label: 'Rubrik 6'
  },
  {
    format: 'paragraph',
    label: 'Normal'
  },
]

const HeadingSelector = ({ selectedBlock, selectHeading }) => {
  const [open, setOpen] = useState(false)
  const [heading, setHeading] = useState('Normal')
  const ref = useRef()
  useOnClickOutside(ref, () => setOpen(false))

  const onHeadingClick = (format, label) => {
    setHeading(label)
    selectHeading(format)
    setOpen(false)
  }

  useEffect(() => {

    if( ! selectedBlock ) {
      return
    }

    const format = headings.find(heading => heading.format === selectedBlock.type)
    if (format) {
      setHeading(format.label) 
    } else {
      setHeading('Normal')
    }
  }, [selectedBlock])

  return (
    <Wrapper ref={ref} role="button" aria-label="Heading selector">
      <Selected onClick={() => setOpen(!open)}>{heading}</Selected>
      {open ?
      <Headings>
        {headings.map(({ format, label }, i) => (
          <Heading key={i} onClick={() => onHeadingClick(format, label)}>{label}</Heading>
        ))}
      </Headings>
      : ''}
    </Wrapper>
  )
}

export default HeadingSelector